export enum TextFieldType {
    Normal = 0,
    Email = 2,
    PhoneNumber = 1
}